import urls from '../api_urls/userBehavior'
import { _post } from '@/axios/request'

// 获取day week month数据
export function getVisitDayWeekMonth (params) {
  return _post(urls.GET_VISIT_DAY_WEEK_MONTH, params)
}

// 获取visit count (echart)
export function getVisitCount (params) {
  return _post(urls.GET_VISIT_COUNT, params)
}

// 获取visit count (echart/月)
export function getVisitCountMonth (params) {
  return _post(urls.GET_VISIT_COUNT_MONTH, params)
}

// 获取visit 根据平台
export function getVisitPlatform (params) {
  return _post(urls.GET_VISIT_PLATFORM, params)
}

// 获取visit 根据模块
export function getVisitModule (params) {
  return _post(urls.GET_VISIT_MODULE, params)
}

// 更新visit 根据角色
export function getVisitRole (params) {
  return _post(urls.GET_VISIT_ROLE, params)
}

// 获取国家分布
export function getCountryDis (params) {
  return _post(urls.GET_COUNTRY_DIS, params)
}

// 获取类型分布
export function getTypeDis (params) {
  return _post(urls.GET_TYPE_DIS, params)
}

// 获取部门分布
export function getDepartmentDis (params) {
  return _post(urls.GET_DEPARTMENT_DIS, params)
}

// 新用户的三个时间维度数量统计
export function getNewUserData (params) {
  return _post(urls.GET_NEW_USER_DATA, params)
}

// 新用户的三个时间维度数量统计(折线图数据)
export function getNewUserChartData (params) {
  return _post(urls.GET_NEW_USER_CHART_DATA, params)
}

// 活跃用户的三个时间维度数量统计
export function getActiveUserData (params) {
  return _post(urls.GET_ACTIVE_USER_DATA, params)
}

// 活跃用户的三个时间维度数量统计(折线图数据)
export function getActiveUserChartData (params) {
  return _post(urls.GET_ACTIVE_USER_CHART_DATA, params)
}

// 活跃天数的三个时间维度数量统计
export function getActiveDayData (params) {
  return _post(urls.GET_ACTIVE_DAY_DATA, params)
}

// 活跃天数的三个时间维度数量统计(柱状图数据)
export function getActiveDayChartData (params) {
  return _post(urls.GET_ACTIVE_DAY_CHART_DATA, params)
}

// 点击量前十的模块
export function getMostlyVisitedModule (params) {
  return _post(urls.GET_MOSTLY_VISITED_MODULE, params)
}

// 活跃时长
export function getOnlineTimeData (params) {
  return _post(urls.GET_ONLINE_TIME_DATA, params)
}

// 活跃时长图表数据
export function getOnlineTimeChartData (params) {
  return _post(urls.GET_ONLINE_TIME_CHART_DATA, params)
}

// 访问页面数
export function getVisitedPageData (params) {
  return _post(urls.GET_VISITED_PAGE_DATA, params)
}

// 访问页面数图表数据
export function getVisitedPageChartData (params) {
  return _post(urls.GET_VISITED_PAGE_CHART_DATA, params)
}

export function getHomePageClick (params) {
  return _post(urls.GET_HOME_PAGE_CLICK, params)
}

export function getSearchPageClick (params) {
  return _post(urls.GET_SEARCH_PAGE_SEARCH, params)
}

export function getRetentionData (params) {
  return _post(urls.GET_RETENTION_DATA, params)
}

export function getCompany (params) {
  return _post(urls.GET_COMPANY, params)
}

export function getExportCount (params) {
  return _post(urls.GET_EXPORT_COUNT, params)
}

export function getActiveCount (params) {
  return _post(urls.GET_ACTIVE_COUNT, params)
}

export function getRegisterCount (params) {
  return _post(urls.GET_REGISTER_COUNT, params)
}

export function getActiveAvgCount (params) {
  return _post(urls.GET_ACTIVE_AVG_COUNT, params)
}

export function getAvgOnlineTime (params) {
  return _post(urls.GET_AVG_ONLINE_TIME, params)
}

export function getAvgVisitedPage (params) {
  return _post(urls.GET_AVG_VISITED_PAGE, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/userBehavior.js